// import newrelic from 'newrelic';

export default function log(data) {
    // console.log('logged to newrelic', data, newrelic);
    // newrelic?.recordCustomEvent?.(data.eventName, {
    //     requestParams: data.requestParams ? JSON.stringify(data.requestParams) : '',
    //     eventStatus: data.status,
    //     eventTypeAction: data.type,
    // });
}
